import React, {useState} from "react"
import zain from "../assets/icons/zain_logo.png"
import xgame from "../assets/icons/logo.png"
import subscribe from "../assets/icons/subscribe.png"
import './Subscribe.scss'
import config from './../config'

function Mobile(props) {
    const [mobile,setMobile] = useState('')
    const [message, setMessage] = useState('')
    const [showAlert, setshowAlert] = useState(false)
    function handleChange(e) {
        setMobile(e.target.value)
    }
    function submitFrom(e) {
        e.preventDefault()
        const url = `${config.get('base')}${config.get('requestOTP')}`
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({'msisdn': mobile}),
            headers:config.get('headers')  
            })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                console.log('result message::', result)
                setMessage(result.message)
                setshowAlert(true)
            },
            (error) => {
                console.log('error:::', error)
                setMessage(error)
                setshowAlert(true)
            })
    }
    function hideAlert(){
        setshowAlert(false)
    }
    return (
        <div className="container m-w">
            <div className="columns is-mobile">
                <div className="column is-full">
                    <div className="card">
                        <div className="card-content">
                            <figure className="image z-s m-1">
                                <img src={zain} alt="zain logo"/>
                            </figure>
                            <figure className="image l-s m-2">
                                <img src={xgame} alt="xgame logo"/>
                            </figure>
                            <figure className="image s-s m-5 pb-5">
                                <img src={subscribe} alt="subcribe icon"/>
                            </figure>
                            <form onSubmit={submitFrom}>
                                <div className="columns is-mobile is-multiline">
                                    <div className="column is-full">
                                        <div className="field">
                                            <label className="label">Enter the Mobile Number</label>
                                            <div className="control">
                                                <input
                                                    className="input"
                                                    type="number"
                                                    value={mobile}
                                                    onChange={handleChange}
                                                    placeholder=""/>
                                            </div>
                                            <p className="help">Please enter your number with country code</p>
                                        </div>
                                        <div className="control">
                                            <button className="button btn-main">Send OTP</button>
                                        </div>
                                        {
                                            showAlert &&
                                            <div className="notification">
                                            <button className="delete" onClick={hideAlert}></button>
                                            {message}
                                        </div>
                                        }
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Mobile